import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import UploadProjectView from '../views/student/UploadProjectView.vue';
import ReviewProjectsView from '../views/review/ReviewProjectsView.vue';
import NotFoundView from '../views/NotFoundView.vue';
import AdminView from '../views/admin/AdminView.vue';
// import AddUserView from '../views/AddUserView.vue';
import UserManage from '../views/UserManage.vue';
import WorkList from '../views/WorkList.vue'
import ReviewDetail from '../views/review/ReviewDetail.vue'
import StudentView from '../views/student/StudentView.vue';
import MyWorkStatus from '../views/student/MyWorkStatus.vue';
const ActivityManage = () => import('../views/component/act/ActivityManage.vue');
const EditActivity = () => import('../views/admin/EditActivity.vue');
const RegistrationIndex = () => import('../views/activity/RegistrationIndex.vue');
const StiManage = () => import('../views/component/sti/StiManage.vue');
const EventManage = () => import('../views/admin/EventManage.vue');



// 路由配置
const routes = [
  {
    path: '/',
    redirect: '/notice'  // 根路径直接重定向到登录页
  },
  {
    path:'/',
    name: 'common',
    component: () => import('../views/HomePage.vue'),
    children: [
      {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: { 
          requiresAuth: false,
          title: '登录 - 创客作品评审平台'
        }
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/HomeIndex.vue'),
        meta: { 
          requiresAuth: false,
          title: '主页'
        }
      },
      {
        path: '/notice',
        name: 'notice',
        // component: NoticeView,
        component: () => import('../views/notice/NoticeIndex.vue'),
        meta: { 
          requiresAuth: false,
          title: '新闻公告'
        }
      },
      {
        path: '/news-detail/:id',
        name: 'NewsDetail',
        component: () => import('../views/notice/NewsDetail.vue'),
        meta: { 
          requiresAuth: false,
          title: '公告详情'
        }
      },
      {
        path: '/activity-list',
        name: 'ActivityList',
        component: () => import('../views/activity/ActivityList.vue'),
        meta: { 
          requiresAuth: false,
          title: '活动列表'
        }
      },
      {
        path: '/to-registration',
        name: 'toRegistration',
        component: () => import('../views/activity/ToRegistrationPage.vue'),
        meta: { 
          requiresAuth: false,
          title: '活动详情'
        }
      },
      {
        path: '/registration',
        name: 'registration',
        component: RegistrationIndex,
        meta: { 
          requiresAuth: true,
          title: '活动报名'
        }
      },
      {
        path: '/compete-work-list/:activityId',
        name: 'CompeteWorkList',
        component: () => import('../views/activity/CompeteWorkList.vue'),
        meta: { 
          requiresAuth: false,
          title: '作品一览'
        }
      },
      {
        path: '/work-detail/:id/:type',
        name: 'WorkDetail',
        component: () => import('../views/activity/WorkDetailAndComment.vue'),
        meta: { 
          requiresAuth: false,
          title: '作品详情'
        }
      },

      {
        path: '/course',
        name: 'course',
        component: () => import('../views/course/CourseIndex.vue'),
        meta: { 
          requiresAuth: false,
          title: '课程学习'
        }
      },
      {
        path: '/course-detail/:id',
        name: 'CourseDetail',
        component: () => import('../views/course/CourseDetail.vue'),
        meta: { 
          requiresAuth: false,
          title: '课程详情'
        }
      },

      {
        path: '/work-track',
        name: 'workTrack',
        component: () => import('../views/work-track/WorkTrack.vue'),
        meta: { 
          requiresAuth: false,
          title: '科创作品跟踪'
        }
      },
      {
        path: '/submit-topic',
        name: 'submitTopic',
        component: () => import('../views/work-track/submitTopic.vue'),
        meta: { 
          requiresAuth: false,
          title: '提交选题'
        }
      },
      {
        path: '/topic-list/:activityId',
        name: 'topicList',
        component: () => import('../views/work-track/TopicList.vue'),
        meta: { 
          requiresAuth: false,
          title: '选题列表'
        }
      },
      {
        path: '/contact-us',
        name: 'ContactUs',
        component: () => import('../views/ContactUsView.vue'),
        meta: { 
          requiresAuth: false,
          title: '联系我们'
        }
      },


    ]
  },
  
  {
    path: '/work-list',
    name: 'WorkList',
    component: WorkList,
    meta: { 
      requiresAuth: false,
      title: '作品列表'
    }
  },
  
  
  



  {
    path: '/',
    name: 'student',
    component: StudentView,
    children: [
      {
        path: '/my-work-status',
        name: 'myWorkStatus',
        component: MyWorkStatus,
        meta: { 
          requiresAuth: true, 
          role: 'student',
          title: '查看作品状态'
        }
      },
      {
        path: '/upload',
        name: 'upload',
        component: UploadProjectView,
        meta: { 
          requiresAuth: true, 
          role: 'student',
          title: '上传作品'
        }
      },
      {
        path: '/my-work-list',
        name: 'myWorkList',
        component: () => import('../views/student/MyWorkList.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'student',
          title: '我的作品'
        }
      },
      {
        path: '/my-work-detail',
        name: 'myWorkDetail',
        component: () => import('../views/student/MyWorkDetail.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'student',
          title: '作品详情'
        }
      },
      {
        path: '/my-topic-list',
        name: 'myTopicList',
        component: () => import('../views/student/MyTopicList.vue'),
        meta: { 
          requiresAuth: false,
          title: '我的选题'
        }
      },
      {
        path: '/my-topic-detail',
        name: 'myTopicDetail',
        component: () => import('../views/student/MyTopicDetail.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'student',
          title: '选题详情'
        }
      },

      {
        path: '/stu-setting',
        name: 'stuSetting',
        component: () => import('../views/student/StudentSetting.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'student',
          title: '设置'
        }
      },
    ]
  },
  // {
  //   path: '/upload',
  //   name: 'upload',
  //   component: UploadProjectView,
  //   meta: { 
  //     requiresAuth: true, 
  //     role: 'student',
  //     title: '上传作品 - 创客作品评审平台'
  //   }
  // },

  {
    path: '/',
    name: 'reviewer',
    component: () => import('../views/review/ReviewView.vue'),
    children: [
      {
        path: '/review',
        name: 'review',
        component: ReviewProjectsView,
        meta: { 
          requiresAuth: true, 
          role: 'reviewer',
          title: '评审作品'
        }
      },
      {
        path: '/review-detail',
        name: 'ReviewDetail',
        component: ReviewDetail,
        meta: { 
          requiresAuth: true, 
          role: 'reviewer',
          title: '评审作品'
        }
      },
      {
        path: '/rev-setting',
        name: 'revSetting',
        component: () => import('../views/review/ReviewerSetting.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'reviewer',
          title: '设置'
        }
      }
    ]
  },

  {
    path: '/',
    name: 'admin',
    component: AdminView,
    children: [
      // {
      //   path: '/overview',
      //   name: 'DataOverview',
      //   component: () => import('../views/admin/DataOverview.vue'),
      //   meta: { 
      //     requiresAuth: true, 
      //     role: 'admin',
      //     title: '数据总览'
      //   }
      // },
      {
        path: '/application-manage',
        name: 'ApplicationManage',
        component: () => import('../views/admin/ApplicationManage.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'admin',
          title: '入驻申请管理'
        }
      },
      {
        path: '/notice-manage',
        name: 'NoticeManage',
        component: () => import('../views/admin/NoticeManage.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'admin',
          title: '通知管理'
        }
      },
      {
        path: '/activity-manage',
        name: 'ActivityManage',
        component: ActivityManage,
        meta: { 
          requiresAuth: true, 
          role: 'admin',
          title: '赛事管理'
        }
      },
      {
        path: '/edit-activity',
        name: 'EditActivity',
        component: EditActivity,
        meta: { 
          requiresAuth: true, 
          role: 'admin',
          title: '编辑活动'
        }
      },
      {
        path: '/results',
        name: 'results',
        component: () => import('../views/admin/ResultsView.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'admin',
          title: '评审结果'
        }
      },
      {
        path: '/sti-manage',
        name: 'StiManage',
        component: StiManage,
        meta: { 
          requiresAuth: true, 
          role: 'admin',
          title: '科创管理'
        }
      },
      {
        path: '/event-manage',
        name: 'EventManage',
        component: EventManage,
        meta: { 
          requiresAuth: true, 
          role: 'admin',
          title: '赛事管理'
        }
      },
      {
        path: '/course-manage',
        name: 'CourseManage',
        component: () => import('../views/admin/CourseManage.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'admin',
          title: '课程管理'
        }
      },
      // {
      //   path: '/add-user',
      //   name: 'addUser',
      //   component: AddUserView,
      //   meta: { 
      //     requiresAuth: true, 
      //     role: 'admin',
      //     title: '添加用户 - 创客作品评审平台'
      //   }
      // },
      {
        path: '/user-manage',
        name: 'UserManage',
        component: UserManage,
        meta: { 
          requiresAuth: true, 
          role: 'admin',
          title: '用户管理'
        }
      }
    ]
  },
  {
    path: '/',
    name: 'employee',
    component: () => import('../views/employee/EmployeeView.vue'),
    children: [
      {
        path: '/emp-act-manage',
        name: 'emp-act-manage',
        component: () => import('../views/component/act/ActivityManage.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'employee',
          title: '赛事管理'
        }
      },
      {
        path: '/emp-sti-manage',
        name: 'emp-sti-manage',
        component: () => import('../views/component/sti/StiManage.vue'),
        meta: { 
          requiresAuth: true, 
          role: 'employee',
          title: '科创列表查看'
        }
      }
    ]
  },
  
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFoundView,
    meta: { 
      requiresAuth: false,
      title: '页面未找到'
    }
  }
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

// 全局路由守卫保持不变...
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '创客作品评审平台';
  
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  
  if (requiresAuth) {
    if (!user) {
      console.log('to:',to)
      console.log('to.fullPath:',to.fullPath)
      next({ 
        path: '/login',
        query: { redirect: to.fullPath },
        // replace: true
      });
    } 

    // 先注释掉
    // else if (to.meta.role && user.role !== to.meta.role) {
    //   next('/login');  // 角色不匹配时跳转到登录页
    // }
    else {
      next();
    }
  } else {
    // console.log('---分割线已经登陆了---')
    // console.log('to:',to)
    // console.log('from:',from)
    if (to.path === '/login' && user) {
      switch(user.role) {
        case 'student':
          next('/my-work-list')
          break;
        case 'reviewer': 
          next('/review');
          // window.open('/review', '_blank');
          // next(false);
          break;
        case 'employee':
          next('/emp-sti-manage');
          break;
        case 'admin':
          next('/sti-manage');
          break;
        default:
          next('/login');
      }
    } else {
      next();
    }
  }
});

export default router;